module.exports = __webpack_public_path__ + "static/media/checklist-dnd.d09f2ca9.svg";